// import { useEffect, useContext } from 'react';
// import { UserAuthContext } from '../Contexts/UserAuthContext';

// export default function GlobalWebSocketListener() {
//   const { AIuser } = useContext(UserAuthContext);
//   const userId = AIuser?._id;

//   useEffect(() => {
//     // Wait until the user is logged in
//     if (!userId) return;

//     // Connect to the WebSocket
//     const ws = new WebSocket(`wss://backend.whalesai.com?userId=${userId}`);

//     ws.onmessage = (event) => {
//       try {
//         const data = JSON.parse(event.data);
//         console.log("WebSocket message received:", data);
        
//         // When a backend task completes (e.g. video generation finishes)
//         if (data.status === 'completed') {
//           console.log("Task completed successfully:", data.message);
          
//           if (data.type === 'video_ai_completed') {
//             const existing = JSON.parse(localStorage.getItem('unviewed_video_ai') || '[]');
//             existing.push(data);
//             localStorage.setItem('unviewed_video_ai', JSON.stringify(existing));
//           } else if (data.type === 'imageAi') {
//             const existing = JSON.parse(localStorage.getItem('unviewed_image_ai') || '[]');
//             existing.push(data.data || data);
//             localStorage.setItem('unviewed_image_ai', JSON.stringify(existing));
//           }

//           window.dispatchEvent(new CustomEvent('backend_task_completed', { detail: data }));
//           // toast.success(data.message, { autoClose: false });
          
//           // If you are using Redux or a global state for the Usage Table, 
//           // you can trigger a re-fetch here so the new transaction appears!
//           // dispatch(fetchUsageHistory());
//         } else if (data.status === 'failed') {
//           console.log("Task failed:", data.message);
//           window.dispatchEvent(new CustomEvent('backend_task_failed', { detail: data }));
//           // toast.error(data.message);
//         }
//       } catch (error) {
//         console.error("Failed to parse WebSocket message:", error);
//       }
//     };

//     ws.onerror = (error) => {
//       console.error("WebSocket error:", error);
//     };

//     return () => {
//       ws.close(); // Clean up when the user logs out
//     };
//   }, [userId]);

//   return null; // This component doesn't render anything visually
// }





import { useEffect, useContext } from 'react';
import { UserAuthContext } from '../Contexts/UserAuthContext';

export default function GlobalWebSocketListener() {
  const { AIuser } = useContext(UserAuthContext);
  const userId = AIuser?._id;

  useEffect(() => {
    // Wait until the user is logged in
    if (!userId) return;

    const ws = new WebSocket(
      `wss://backend.whalesai.com?userId=${userId}`
    );

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        console.log(
          "[GlobalWebSocketListener] WebSocket message received:",
          data
        );

        /*
         * =====================================================
         * IMPORTANT
         *
         * Different backend events can keep status in
         * different places.
         *
         * Advertisement image event:
         * data.data.status === "completed"
         *
         * Older events:
         * data.status === "completed"
         * =====================================================
         */

        const status =
          data?.status ||
          data?.data?.status;

        /*
         * =====================================================
         * COMPLETED
         * =====================================================
         */

        if (status === "completed") {
          console.log(
            "[GlobalWebSocketListener] Task completed successfully:",
            data?.message
          );

          /*
           * VIDEO AI
           */
          if (data.type === "video_ai_completed") {
            const existing = JSON.parse(
              localStorage.getItem(
                "unviewed_video_ai"
              ) || "[]"
            );

            existing.push(data);

            localStorage.setItem(
              "unviewed_video_ai",
              JSON.stringify(existing)
            );
          }

          /*
           * IMAGE AI
           */
          else if (data.type === "imageAi") {
            const existing = JSON.parse(
              localStorage.getItem(
                "unviewed_image_ai"
              ) || "[]"
            );

            existing.push(
              data.data || data
            );

            localStorage.setItem(
              "unviewed_image_ai",
              JSON.stringify(existing)
            );
          }

          /*
           * IMPORTANT:
           * Advertisement Video AI image completion
           * will also come through this event.
           *
           * Example:
           *
           * action:
           * "ad_video_ai_image_completed"
           *
           * data.data.imageType:
           * "character"
           *
           * data.data.imageUrl:
           * "https://..."
           */

          window.dispatchEvent(
            new CustomEvent(
              "backend_task_completed",
              {
                detail: data,
              }
            )
          );

          console.log(
            "[GlobalWebSocketListener] backend_task_completed dispatched:",
            data
          );
        }

        /*
         * =====================================================
         * FAILED
         * =====================================================
         */

        else if (status === "failed") {
          console.log(
            "[GlobalWebSocketListener] Task failed:",
            data?.message
          );

          window.dispatchEvent(
            new CustomEvent(
              "backend_task_failed",
              {
                detail: data,
              }
            )
          );

          console.log(
            "[GlobalWebSocketListener] backend_task_failed dispatched:",
            data
          );
        }

        /*
         * =====================================================
         * UNKNOWN / OTHER MESSAGE
         * =====================================================
         */

        else {
          console.log(
            "[GlobalWebSocketListener] Non-task WebSocket message:",
            data
          );
        }
      } catch (error) {
        console.error(
          "[GlobalWebSocketListener] Failed to parse WebSocket message:",
          error
        );
      }
    };

    ws.onerror = (error) => {
      console.error(
        "[GlobalWebSocketListener] WebSocket error:",
        error
      );
    };

    ws.onclose = () => {
      console.log(
        "[GlobalWebSocketListener] WebSocket connection closed."
      );
    };

    return () => {
      ws.close();
    };
  }, [userId]);

  return null;
}